<template>
  <header class="header-login">
    <img src="img/logo.svg" alt="">
  </header>
</template>

<script>
  export default {
    name: "HeaderLogin"
  }
</script>

<style lang="scss">
  .header-login {
    padding: 25px 30px;
    @media (max-width: 575px) {
      text-align: center;
    }
  }
</style>